import React, { useState } from 'react';
import '../styles/B2BInquiry.css';

const B2BInquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    city: '',
    productInterest: '',
    quantity: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const products = [
    'QuickFit ANC R'
  ];

  const quantityOptions = [
    '10-50 units',
    '51-100 units',
    '101-250 units',
    '251-500 units',
    '500+ units'
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        city: '',
        productInterest: '',
        quantity: '',
        message: ''
      });
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    }, 1500);
  };

  const benefits = [
    { icon: '💰', text: 'Best B2B Pricing', desc: 'Special distributor rates' },
    { icon: '🚀', text: 'Fast Delivery', desc: 'Faster Delivery' },
    { icon: '🇮🇳', text: 'Made in India', desc: 'Quality assured' },
    { icon: '🤝', text: 'Customer Support', desc: 'Dedicated relationship manager' },
    { icon: '🎨', text: 'Custom Branding', desc: 'Private label available' },
    { icon: '📦', text: 'Low MOQ', desc: 'Start small, grow big' }
  ];

  return (
    <section id="b2b-inquiry" className="b2b-inquiry-section">
      <div className="b2b-inquiry-container">
        
        {/* Section Header */}
        <div className="b2b-inquiry-header">
          <span className="b2b-inquiry-tagline">Start Your Journey</span>
          <h2 className="b2b-inquiry-title">
            Request a <span className="b2b-inquiry-highlight">B2B Quote</span>
          </h2>
          <div className="b2b-inquiry-underline"></div>
          <p className="b2b-inquiry-subtitle">
            Fill out the form below and our team will get back to you within 24 hours.
          </p>
        </div>

        <div className="b2b-inquiry-wrapper">
          
          {/* Left Side - Benefits & Info */}
          <div className="b2b-inquiry-left">
            <div className="b2b-inquiry-benefits">
              <h3>Why Partner With Us?</h3>
              <div className="b2b-inquiry-benefits-grid">
                {benefits.map((benefit, index) => (
                  <div key={index} className="b2b-inquiry-benefit-item">
                    <div className="b2b-inquiry-benefit-icon">{benefit.icon}</div>
                    <div className="b2b-inquiry-benefit-content">
                      <strong>{benefit.text}</strong>
                      <span>{benefit.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="b2b-inquiry-contact-info">
              <h3>Need Instant Help?</h3>
              <div className="b2b-inquiry-contact-item">
                <span className="b2b-inquiry-contact-icon">📞</span>
                <div>
                  <strong>Call Us</strong>
                  <a href="tel:03323240508">033-23240508</a>
                </div>
              </div>
              <div className="b2b-inquiry-contact-item">
                <span className="b2b-inquiry-contact-icon">💬</span>
                <div>
                  <strong>WhatsApp</strong>
                  <a href="https://wa.me/919748691530">+91 9748691530</a>
                </div>
              </div>
              <div className="b2b-inquiry-contact-item">
                <span className="b2b-inquiry-contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:info@paplhear.com">info@paplhear.com</a>
                </div>
              </div>
            </div>

            
          </div>

          {/* Right Side - Inquiry Form */}
          <div className="b2b-inquiry-right">
            <div className="b2b-inquiry-form-wrapper">
              <div className="b2b-inquiry-form-header">
                <h3>Get a Quote</h3>
                <p>Fill the form and get best B2B pricing</p>
              </div>

              {isSubmitted ? (
                <div className="b2b-inquiry-success">
                  <div className="b2b-inquiry-success-icon">✓</div>
                  <h3>Thank You!</h3>
                  <p>Your inquiry has been submitted successfully. Our team will contact you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="b2b-inquiry-form">
                  <div className="b2b-inquiry-row">
                    <div className="b2b-inquiry-input-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter your full name"
                      />
                    </div>
                    <div className="b2b-inquiry-input-group">
                      <label>Company Name *</label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        required
                        placeholder="Enter your company name"
                      />
                    </div>
                  </div>

                  <div className="b2b-inquiry-row">
                    <div className="b2b-inquiry-input-group">
                      <label>Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="enter@example.com"
                      />
                    </div>
                    <div className="b2b-inquiry-input-group">
                      <label>Phone Number *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="Enter your mobile number"
                      />
                    </div>
                  </div>

                  <div className="b2b-inquiry-row">
                    <div className="b2b-inquiry-input-group">
                      <label>City</label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        placeholder="Enter your city"
                      />
                    </div>
                    <div className="b2b-inquiry-input-group">
                      <label>Product Interest *</label>
                      <select
                        name="productInterest"
                        value={formData.productInterest}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Product</option>
                        {products.map((product, index) => (
                          <option key={index} value={product}>{product}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="b2b-inquiry-row">
                    <div className="b2b-inquiry-input-group">
                      <label>Expected Quantity *</label>
                      <select
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Quantity Range</option>
                        {quantityOptions.map((option, index) => (
                          <option key={index} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                    <div className="b2b-inquiry-input-group">
                      <label>Custom Branding Required?</label>
                      <select name="customBranding">
                        <option value="No">No</option>
                        <option value="Yes">Yes, Interested</option>
                      </select>
                    </div>
                  </div>

                  <div className="b2b-inquiry-input-group full-width">
                    <label>Message / Requirements</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      placeholder="Tell us about your specific requirements..."
                    ></textarea>
                  </div>

                  <button type="submit" className="b2b-inquiry-submit" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="b2b-inquiry-spinner"></span>
                        Sending...
                      </>
                    ) : (
                      <>
                        Request Quote
                        <svg className="b2b-inquiry-submit-icon" viewBox="0 0 24 24" fill="none">
                          <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </>
                    )}
                  </button>

                  <p className="b2b-inquiry-note">
                    * We respect your privacy. Your information is secure with us.
                  </p>
                </form>
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default B2BInquiry;